import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {PERSISTOR, STORE} from 'appredux/index';
import {FirebaseAppProvider, useAnalytics} from 'reactfire';
import {FIREBASE_CONFIG} from 'constants/index';
import firebase from 'firebase';
import {useLocation} from 'react-router';
import SocketEventProvider from 'appsockets/SocketEventProvider';
import {PersistGate} from 'redux-persist/integration/react';
import {AppLoader} from './AppLoader';
import {createRoot} from 'react-dom/client';
import process from 'process';
window.process = process;

import './suppressResizeObserverError';

firebase.initializeApp(FIREBASE_CONFIG);
firebase.analytics();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <SocketEventProvider>
    <Provider store={STORE}>
      <PersistGate loading={<AppLoader />} persistor={PERSISTOR}>
        <FirebaseAppProvider firebaseConfig={FIREBASE_CONFIG}>
          <BrowserRouter>
            <App />
            <PageViewLogger />
          </BrowserRouter>
        </FirebaseAppProvider>
      </PersistGate>
    </Provider>
  </SocketEventProvider>,
);

// eslint-disable-next-line @typescript-eslint/naming-convention,require-jsdoc
function PageViewLogger() {
  const analytics = useAnalytics();
  const location = useLocation();
  // By passing `location.pathname` to the second argument of `useEffect`,
  // we only log on first render and when the `pathname` changes
  useEffect(() => {
    analytics.logEvent('page-view', {
      page_title: location.pathname,
      path_name: location.pathname,
    });
  }, [location.pathname, analytics]);

  return null;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
